import React from 'react';
import Linesheets from 'components/Linesheets';

const LinesheetsPage = () => {
  return <Linesheets />;
};

export default LinesheetsPage;
